import styles from "../VideoConference.module.scss";
import styles2 from '../VideoConferenceV2.module.scss';
import {useEffect, useState} from "react";

export const mainFeedSize = 4;
export const maxPublishers = 4;
// export const mainFeedSize = 1;
export const otherFeedSize = 1;

export const maxParticipants = 8;

export const maxPctWithShare = 4;
// export const otherFeedSize = 1;

export const camSearchParam = "camera"

export enum ConnectionState {
    None,
    Connected,
    Connecting,
    Disconnected,
    Error
}

export enum Sidebar {
    None,
    Chat,
    Member,
    Background,
}

export const Breakpoints = {
    mobile: 320,
    mobileLandscape: 480,
    tablet: 768,
    tabletLandscape: 1024,
    desktop: 1200,
    desktopLarge: 1500,
    desktopWide: 1920,
}

export const BITRATE = 256000;
export const FPS_CAPTURE = 25;

export const getGridArea = (num: number) => {
    let gridArea: string;
    switch (num) {
        case 0:
            gridArea = styles.first;
            break;
        case 1:
            gridArea = styles.second;
            break;
        case 2:
            gridArea = styles.third;
            break;
        case 3:
            gridArea = styles.forth;
            break;
        case 4:
            gridArea = styles.fifth;
            break;
        case 5:
            gridArea = styles.sixth;
            break;
        case 6:
            gridArea = styles.seventh;
            break;
        case 7:
            gridArea = styles.eighth;
            break;
        case 8:
            gridArea = styles.ninth;
            break;
        case 9:
            gridArea = styles.tenth;
            break;
        default:
            gridArea = styles.first;
    }
    return gridArea;
}

export const getScreen = (feedSize: number) => {
    let remoteContainer: string;
    if (feedSize > 9) {
        return styles.ConferenceContainer9;
    }
    switch (feedSize) {
        case 1:
            remoteContainer = styles.ConferenceContainer1;
            break;
        case 2:
            remoteContainer = styles.ConferenceContainer2;
            break;
        case 3:
            remoteContainer = styles.ConferenceContainer3;
            break;
        case 4:
            remoteContainer = styles.ConferenceContainer4;
            break;
        case 5:
            remoteContainer = styles.ConferenceContainer5;
            break;
        case 6:
            remoteContainer = styles.ConferenceContainer6;
            break;
        case 7:
            remoteContainer = styles.ConferenceContainer7;
            break;
        case 8:
            remoteContainer = styles.ConferenceContainer8;
            break;
        case 9:
            remoteContainer = styles.ConferenceContainer9;
            break;
        case 10:
            remoteContainer = styles.ConferenceContainer10;
            break;
        default:
            remoteContainer = styles.ConferenceContainer1;
    }
    return remoteContainer;
}

export const getScreenV2 = (feedSize: number, shareFeed: any, hasMore: boolean = false) => {
    feedSize += hasMore ? 1 : 0;
    if (shareFeed) {
        // return styles2.ConfConShare1;
        switch (feedSize) {
            case 1:
                return styles2.ConfConShare2;
            case 2:
                return styles2.ConfConShare3;
            case 3:
                return styles2.ConfConShare4;
            case 4:
                return styles2.ConfConShare5;
            case 5:
                return styles2.ConfConShare6;
            case 6:
                return styles2.ConfConShare7;
            // case 7:
            //     return styles2.ConfConShare8;
            default:
                return styles2.ConfConShare7;
        }
    }
    let remoteContainer: string;
    if (feedSize > maxParticipants) {
        return styles2.ConferenceContainer10;
    }
    switch (feedSize) {
        case 1:
            remoteContainer = styles2.ConferenceContainer2;
            break;
        case 2:
            remoteContainer = styles2.ConferenceContainer3;
            break;
        case 3:
            remoteContainer = styles2.ConferenceContainer4;
            break;
        case 4:
            remoteContainer = styles2.ConferenceContainer5;
            break;
        case 5:
            remoteContainer = styles2.ConferenceContainer6;
            break;
        case 6:
            remoteContainer = styles2.ConferenceContainer7;
            break;
        case 7:
            remoteContainer = styles2.ConferenceContainer8;
            break;
        case 8:
            remoteContainer = styles2.ConferenceContainer9;
            break;
        case 9:
            remoteContainer = styles2.ConferenceContainer10;
            break;
        default:
            remoteContainer = styles2.ConferenceContainer1;
    }
    return remoteContainer;
}

export const getMyScreen = (feedSize: number) => {
    let remoteContainer: string;
    if (feedSize > 8) {
        return styles2.ninth;
    }
    switch (feedSize) {
        case 1:
            remoteContainer = styles2.second;
            break;
        case 2:
            remoteContainer = styles2.third;
            break;
        case 3:
            remoteContainer = styles2.forth;
            break;
        case 4:
            remoteContainer = styles2.fifth;
            break;
        case 5:
            remoteContainer = styles2.sixth;
            break;
        case 6:
            remoteContainer = styles2.seventh;
            break;
        case 7:
            remoteContainer = styles2.eighth;
            break;
        case 8:
            remoteContainer = styles2.ninth;
            break;
        default:
            remoteContainer = styles2.first;
    }
    return remoteContainer;
}

export const getGridAreaV2 = (num: number) => {
    let gridArea: string;
    switch (num) {
        case 0:
            gridArea = styles.first;
            break;
        case 1:
            gridArea = styles.second;
            break;
        case 2:
            gridArea = styles.third;
            break;
        case 3:
            gridArea = styles.forth;
            break;
        case 4:
            gridArea = styles.fifth;
            break;
        case 5:
            gridArea = styles.sixth;
            break;
        case 6:
            gridArea = styles.seventh;
            break;
        case 7:
            gridArea = styles.eighth;
            break;
        case 8:
            gridArea = styles.ninth;
            break;
        default:
            gridArea = styles.first;
    }
    return gridArea;
}

export const generateDisplay = (username: string, postfix: string, isShare: boolean = false) => {
    return `${username}:${isShare ? "share" : ""}:${postfix}`
}

export const getDisplayName = (display: string) => {
    if (display != null) {
        let names = display.trim().split(":");
        return names[0];
    }
    return display;
}

export const isShareFeed = (display: string) => {
    if (!display) return false;
    let displayArr = display.trim().split(":");
    return displayArr[1] === "share";
}

export const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth)
            setHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Return the width so we can use it in our components
    return { width, height };
}